<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <!-- 设备系统 -->
        <div class="container" style="float:right;width:95%;">
            <div style="height:80px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.region" clearable placeholder="请选择区域">
                            <el-option
                                v-for="item in regions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.address" placeholder="请输入设备位置"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.className" placeholder="所属机构"></el-input>
                    </div>
                </div>
                <br>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="姓名"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.identityCard" placeholder="身份证"></el-input>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;"> 
                    <el-date-picker
                        v-model="form.startDatetime"
                        type="datetime"
                        placeholder="开始时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker> 
                        
                </div>
                <div style="display: inline-block; height:40px;">
                    <el-date-picker
                        v-model="form.endDatetime"
                        type="datetime"
                        placeholder="结束时间"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker> 
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
                    <el-button type="primary" icon="search" @click="exportExcel">导出Excel</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all>
                <!-- <el-table-column type="selection" width="55" ></el-table-column> -->
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                 <el-table-column prop="" label="头像"  :show-overflow-tooltip="true" width="70px" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.imageUrl != null && scope.row.imageUrl != ''">
                           <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.imageUrl" lazy="loading"
                                    style="max-height:250px; max-width:330px"/>
                                <img slot="reference" :src="scope.row.imageUrl"  lazy="loading" :alt="scope.row.imageUrl" style="max-height: 50px;max-width: 130px">
                            </el-popover>
                        </div>
                        <div v-else>
                            未上传
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="personType" label="人员类型" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.personType == 1">
                            学生
                        </div>
                        <div v-else-if="scope.row.personType == 2">
                            教职
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="80"></el-table-column>
                <el-table-column prop="identityCard" label="身份证" width="100"></el-table-column>
                <el-table-column prop="sex" label="性别" width="50">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sex == 1">
                            男
                        </div>
                        <div v-else-if="scope.row.sex == 2">
                            女
                        </div>
                        <div v-else-if="scope.row.sex == 0">
                            未知
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="className" label="所属机构" width="100"></el-table-column>
                <el-table-column prop="sign" label="进出标志" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sign == 1">
                            进入
                        </div>
                        <div v-else-if="scope.row.sign == 2">
                            出去
                        </div>
                        <div v-else-if="scope.row.sign == 3">
                            无
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="deviceNo" label="设备编号" width="130"></el-table-column>
                <el-table-column prop="address" label="设备位置" width="150"></el-table-column>
                <el-table-column prop="gmtCreate" label="通行时间" width="150"></el-table-column>
                <el-table-column prop="remark" label="备注" ></el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import http from '../../../../common/http';

    export default {
        name:"Traffic",
        data(){
            return{
                menuName:"",
                loading:false,
                loadingText:"",
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    name:"",
                    identityCard:"",
                    region:"",
                    address:"",
                    startDatetime:"",
                    endDatetime:"",
                    deptId:"",
                    className:""
                },
                defaultProps: {
                    children: 'children',
                    label: 'text'
                },
                depts:[],
                data:[],
                regions:[{
                    value:'',
                    label:'全部'
                },{
                    value:'门',
                    label:'校园大门'
                },{
                    value:'班',
                    label:'教室'
                },{
                    value:'楼',
                    label:'楼梯'
                },{
                    value:'宿舍',
                    label:'宿舍大门'
                },{
                    value:'厨',
                    label:'食堂后厨'
                }]
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
            this.getDeptData();
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // deptCheck(){
            //    this.deptId=this.$refs['rootTree'].getCheckedKeys();
            //    this.getData();
            // },
            getData(){
                this.loading=true;
                this.loadingText="正在加载中...";
                let url  = this.listTrafficUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    name:this.form.name,
                    identityCard:this.form.identityCard,
                    startDatetime:this.form.startDatetime==null?"":this.form.startDatetime,
                    endDatetime:this.form.endDatetime==null?"":this.form.endDatetime,
                    address:this.form.address,
                    region:this.form.region,
                    deptId:this.form.deptId,
                    className:this.form.className
                };
                
                // console.log(JSON.stringify(data))
                // return;
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
           },
           exportExcel(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";

                let url=this.excelDownloadTrafficUrl;
                let param = new URLSearchParams();
                param.append('isPage', this.common.isPage);
                param.append('page', this.common.page);
                param.append('limit', this.common.pageSize);
                param.append('name', this.form.name);
                param.append('identityCard', this.form.identityCard);
                param.append('startDatetime', this.form.startDatetime==null?"":this.form.startDatetime);
                param.append('endDatetime', this.form.endDatetime==null?"":this.form.endDatetime);
                param.append('address', this.form.address);
                param.append('region', this.form.region);
                param.append('deptId', this.form.deptId);
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    // console.log(decodeURI(res.headers['filename']));
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", '通行报表.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    // this.$Notice.error({
                    //     title: "错误",
                    //     desc: "系统数据错误"
                    // });
                    console.log(error);
                    this.loading=false;
                });
           },
           handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.trafficRemoveUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            },
            //批量删除管理员
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/device/traffic/Traffic.vue